import { FC, ReactNode } from 'react'

import styles from './modalFooter.module.scss'

export interface Props {
  title?: string
  content?: string | ReactNode | undefined
  customStyles?: any
  timer?: ReactNode
  icon?: ReactNode
  buttonComponent?: ReactNode
  dataTestId: string
}

const ModalFooter: FC<Props> = (props) => {
  const {
    title,
    content,
    customStyles,
    timer,
    buttonComponent,
    icon,
    dataTestId
  } = props

  if (!title && !content) {
    return (
      <div className={styles.bottom}>
        <div className={styles.buttonsComponents}>{buttonComponent}</div>
      </div>
    )
  }

  return (
    <div className={styles.bottom}>
      <div
        data-testid={dataTestId}
        className={`${styles.bottomContent} ${styles[customStyles.content]}`}
      >
        {timer ||
          (icon && (
            <div className={`${styles.bottomIcn} ${styles[customStyles.icon]}`}>
              {timer || icon}
            </div>
          ))}
        <div className={`${styles.bottomText}`}>
          <div className={`${styles.bottomTextTitle}`}>{title}</div>
          <div className={`${styles.bottomTextContent}`}>{content}</div>
        </div>
      </div>
      <div className={styles.buttonsComponents}>{buttonComponent}</div>
    </div>
  )
}

export default ModalFooter
